module.exports = __webpack_public_path__ + "static/img/11.3640da8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/sp/11.png
// module id = zwJU
// module chunks = 0